import styled from '@emotion/styled'

export const InvoicesBatchListContainer = styled.div`
  div[class^='Row-overflowXAuto'], div[class*='Row-overflowXAuto'] {
    overflow-x: unset;
  }
`
